var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "shopOrder" },
    _vm._l(_vm.shopsData, function(shop) {
      return _c("div", { key: shop.shopId, staticClass: "shopList" }, [
        _c(
          "div",
          { staticClass: "orderList" },
          _vm._l(shop.skus, function(order) {
            return _c("div", { key: order.skuId, staticClass: "orderItem" }, [
              _c("div", { staticClass: "commodity itemBox" }, [
                _c("img", {
                  attrs: { src: order.image, alt: order.productName }
                }),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(order.productName))])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "attributes itemBox" }, [
                _c("span", [_vm._v(_vm._s(order.values.join("/")))])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "unitPrice itemBox" }, [
                _vm._v("￥" + _vm._s(order.price))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "numberBox itemBox" }, [
                _vm._v(_vm._s(order.number))
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "activityBox itemBox" }, [
                _vm._v(
                  _vm._s(
                    _vm.type == 0
                      ? "无"
                      : _vm.type == 1
                      ? "拼团"
                      : _vm.type == 2
                      ? "秒杀"
                      : _vm.type == 3
                      ? "折扣"
                      : ""
                  )
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "totalBox itemBox" }, [
                _vm._v("￥" + _vm._s(order.total))
              ])
            ])
          }),
          0
        ),
        _vm._v(" "),
        _c("div", { staticClass: "orderTotalBox" }, [
          _c("div", { staticClass: "shippingBox" }, [
            _vm._v("运费：￥" + _vm._s(shop.distribution.distributionPrice))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "orderTotalBox" }, [
            _vm._v("订单合计："),
            _c("b", [
              _vm._v(
                "￥" + _vm._s(shop.total + shop.distribution.distributionPrice)
              )
            ])
          ])
        ])
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-5d09d465", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-5d09d465","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/orderInfo/shopOrder.vue
// module id = null
// module chunks = 